import { useQuery } from "@tanstack/react-query";

import GlobalAppAPI from "../../../../api/api/GlobalAppAPI";

export function useGlobalAppViews(
  globalAppID: string,
  enabled: boolean,
  type: "views" | "subviews"
) {
  const globalAppViewsData = useQuery({
    queryKey: ["globalAppViews", globalAppID],
    queryFn: async () =>
      GlobalAppAPI.getGlobalAppViews(globalAppID, type).then((data) => {
        return {
          views: data.data.data.views,
          appName: data.data.data.appName,
          moduleAPINames: data.data.data.moduleAPINames,
        };
      }),
    enabled: enabled,
  });

  return {
    views: globalAppViewsData.data?.views,
    appName: globalAppViewsData.data?.appName,
    validModuleAPINames: globalAppViewsData.data?.moduleAPINames,
    loadingViews: globalAppViewsData.isLoading,
  };
}
